import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./CardCarousel.css";

const CardCarousel = ({ title, cards }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsToShow = 3; // Number of cards visible at a time

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + itemsToShow) % cards.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) => (prev - itemsToShow + cards.length) % cards.length
    );
  };

  const swipeHandlers = useSwipeable({
    onSwipedLeft: nextSlide,
    onSwipedRight: prevSlide,
    trackMouse: true, // Enable mouse swiping for testing
  });

  return (
    <div className="card-carousel">
      <h2 className="carousel-title">{title}</h2>

      {/* Left Arrow */}
      <button className="carousel-arrow left" onClick={prevSlide}>
        &#8592;
      </button>

      {/* Carousel Content */}
      <div className="carousel-container" {...swipeHandlers}>
        <div
          className="carousel-slides"
          style={{
            transform: `translateX(-${(currentIndex / itemsToShow) * 100}%)`,
          }}
        >
          {cards.map((card, index) => (
            <div key={index} className="carousel-card">
              <img src={card.src} alt={card.alt} className="carousel-image" />
              <div className="card-content">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Right Arrow */}
      <button className="carousel-arrow right" onClick={nextSlide}>
        &#8594;
      </button>
    </div>
  );
};

export default CardCarousel;
